import React, { useEffect, useState, useRef } from "react";
import IncludeSideBar from "../../Components/Sidebar/IncludeSideBar";
import './GiftScreen.css';
import useAuth from '../../../src/useAuth'
import { MEDIA_SERVER_URL } from "../../constants/constants";
const GiftListingsapi = require("../../apis/gift_listing");


function GiftsScreen() {
  const { user } = useAuth()
  // const role = user ? user.role : null;
  // console.log(user?.permissions?.Videos?.Delete?.selected, "video section user?.permissions?.Users")
  const hasAddGift = user?.permissions?.Gifts?.['Add Gift']?.selected || user?.role === 'superadmin';
  const hasDeleteGift = user?.permissions?.Gifts?.['Delete Gift']?.selected || user?.role === 'superadmin';

  const [giftListings, setGiftListings] = useState([]);
  const [giftData, setGiftData] = useState({
    gift_image: null,
    gift_name: "",
    cost: "",
    category: "functional",
    video_file: null
  });
  const [filteredGiftListings, setFilteredGiftListings] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingGiftId, setEditingGiftId] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showFullImage, setShowFullImage] = useState(false);
  const [currentFullImage, setCurrentFullImage] = useState("");
  const formRef = useRef(null);

  const openFullImage = (url) => {
    setCurrentFullImage(url);
    setShowFullImage(true);
  };

  const closeFullImage = () => {
    setShowFullImage(false);
    setCurrentFullImage("");
  };

  const toggleFormVisibility = () => {
    if (isFormVisible) {
      if (editMode && scrollPosition > 0) {
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
      }
      setEditMode(false);
      setEditingGiftId(null);
      setGiftData({
        gift_image: null,
        gift_name: "",
        cost: "",
        category: "functional",
        video_file: null
      });
      setScrollPosition(0);
    }
    setIsFormVisible(!isFormVisible);
  };

  const handleAddGiftClick = () => {
    if (isFormVisible && editMode) {
      // If form is visible but in Edit mode, switch to Add mode
      setEditMode(false);
      setEditingGiftId(null);
      setGiftData({
        gift_image: null,
        gift_name: "",
        cost: "",
        category: "functional",
        video_file: null
      });
      // Scroll to form to ensure user sees the cleared state
      formRef.current?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Otherwise use the standard toggle logic
      toggleFormVisibility();
    }
  };


  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    const fileValue = type === "file" ? files[0] : value;
    setGiftData({ ...giftData, [name]: fileValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    if (giftData.gift_image) formData.append("gift_image", giftData.gift_image);
    if (giftData.video_file) formData.append("gift_video", giftData.video_file);
    formData.append("gift_name", giftData.gift_name);
    formData.append("cost", giftData.cost);
    formData.append("category", giftData.category);

    try {
      let response;
      if (editMode) {
        response = await GiftListingsapi.updateGiftListing(editingGiftId, formData);
        console.log("Updated:", response);
      } else {
        response = await GiftListingsapi.addGiftListing(formData);
        console.log("Added:", response);
      }

      setGiftData({
        gift_image: null,
        gift_name: "",
        cost: "",
        category: "functional",
        video_file: null
      });
      
      if (scrollPosition > 0) {
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      setEditMode(false);
      setEditingGiftId(null);
      setIsFormVisible(false);
      setScrollPosition(0);
      getGiftListing();

    } catch (error) {
      console.error("Error submitting gift listing:", error);
    }
  };

  const getGiftListing = async () => {
    try {
      const response = await GiftListingsapi.getGiftListing();
      console.log(response, "newresponse");
      setGiftListings(response.data);
    } catch (error) {
      console.error("Error fetching gift listings:", error);
    }
  };

  useEffect(() => {
    getGiftListing();
  }, []);

  useEffect(() => {
    // Filter the gift listings based on the selected category whenever listings or activeCategory changes
    const filtered = activeCategory 
      ? giftListings.filter((gift) => gift.category === activeCategory)
      : giftListings;
    setFilteredGiftListings(filtered);
  }, [giftListings, activeCategory]);


  const filterGifts = (category) => {
    setActiveCategory(prev => prev === category ? null : category);
  };



  const handleDeleteGift = async (giftId) => {
    try {
      // Send a request to your API to delete the gift by its ID
      await GiftListingsapi.deleteGiftListing(giftId);
      // After successful deletion, update the gift listings
      getGiftListing();
    } catch (error) {
      console.error("Error deleting gift:", error);
    }
  };

  const handleEditClick = (gift) => {
    setScrollPosition(window.scrollY);
    setEditMode(true);
    setEditingGiftId(gift.id);
    setGiftData({
      gift_image: null, // Keep existing if not changed
      gift_name: gift.gift_name,
      cost: gift.cost,
      category: gift.category,
      video_file: null // Keep existing if not changed
    });
    setIsFormVisible(true);
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleNoAccess = () => {
    alert('You are not able to access this feature.');
  };

  return (
    <IncludeSideBar>
      <div>
        <div className="screen-header">Gift Section</div>
        <button onClick={() => {
          if (hasAddGift) {
            handleAddGiftClick()

          } else {
            handleNoAccess()
          }
        }}
          style={{
            backgroundColor:
              !hasAddGift
                ? '#C5C6C7'
                : '', // Set red background when there is access
            cursor: !hasAddGift ? 'not-allowed' : 'pointer', // Changes cursor when disabled
          }}
          className="add-gift-button">
          Add Gift
        </button>

        {isFormVisible && (
          <form ref={formRef} onSubmit={handleSubmit} className="form-container">
            <div className="form-header">
              {editMode ? `Edit: ${giftData.gift_name}` : "New Gift"}
            </div>
            
            <div className="form-item-full">
              <label htmlFor="category">Category</label>
              <select
                id="category"
                name="category"
                value={giftData.category}
                onChange={handleChange}
                required
              >
                <option value="functional">Functional</option>
                <option value="mood">Mood</option>
                <option value="vipGifts">VIP Gifts</option>
              </select>
            </div>

            <div className="form-item-full">
              <label htmlFor="giftName">Gift Name</label>
              <input
                type="text"
                id="giftName"
                name="gift_name"
                placeholder="Name"
                value={giftData.gift_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-item-full">
              <label htmlFor="cost">Cost</label>
              <input
                type="number"
                id="cost"
                name="cost"
                placeholder="0"
                value={giftData.cost}
                onChange={handleChange}
                required
              />
            </div>

            <div className="file-upload-box">
              <label htmlFor="giftImage">Static Image</label>
              {(giftData.gift_image || (editMode && editingGiftId)) && (
                <img 
                  src={giftData.gift_image instanceof File 
                    ? URL.createObjectURL(giftData.gift_image) 
                    : (editingGiftId && giftListings.find(g => g.id === editingGiftId)?.gift_image 
                        ? `${MEDIA_SERVER_URL}/${giftListings.find(g => g.id === editingGiftId).gift_image}`
                        : '')
                  } 
                  alt="Image" 
                  onClick={(e) => openFullImage(e.target.src)}
                  title="Click to view full size"
                />
              )}
              <input
                type="file"
                id="giftImage"
                name="gift_image"
                onChange={handleChange}
                accept="image/*,.svg,image/svg+xml"
                required={!editMode}
              />
            </div>

            <div className="file-upload-box">
              <label htmlFor="videoFile">Gift GIF/JSON</label>
              {(giftData.video_file || (editMode && editingGiftId && giftListings.find(g => g.id === editingGiftId)?.gift_video)) && (
                <img 
                  src={giftData.video_file instanceof File 
                    ? URL.createObjectURL(giftData.video_file) 
                    : (editingGiftId && giftListings.find(g => g.id === editingGiftId)?.gift_video
                        ? `${MEDIA_SERVER_URL}/${giftListings.find(g => g.id === editingGiftId).gift_video}`
                        : '')
                  } 
                  alt="GIF" 
                  onClick={(e) => openFullImage(e.target.src)}
                  title="Click to view full size"
                />
              )}
              <input
                type="file"
                id="videoFile"
                name="video_file"
                onChange={handleChange}
                accept="image/gif,video/*,.json"
              />
            </div>

            <div className="form-actions">
              <button className="btn-submit" type="submit">
                {editMode ? "Save" : "Create"}
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={toggleFormVisibility}
              >
                Cancel
              </button>
            </div>
          </form>
        )}


        <div className="category-buttons">
          <button
            className={`button ${activeCategory === "functional" ? "active" : ""}`}
            onClick={() => filterGifts("functional")}
          >
            Functional
          </button>
          <button
            className={`button ${activeCategory === "mood" ? "active" : ""}`}
            onClick={() => filterGifts("mood")}
          >
            Dream
          </button>
          <button
            className={`button ${activeCategory === "vipGifts" ? "active" : ""}`}
            onClick={() => filterGifts("vipGifts")}
          >
            VIP Gifts
          </button>
        </div>



        <div className="card-container">
          {filteredGiftListings.map((gift) => (
            <div key={gift.id} className="card">
              <div className={`category-badge ${gift.category}`}>
                {gift.category}
              </div>
              <img
                src={`${MEDIA_SERVER_URL}/${gift.gift_image}`}
                alt={gift.gift_name}
              />
              <div className="card-details">
                <div>
                  <strong>Gift Name</strong> <span>{gift.gift_name}</span>
                </div>
                <div>
                  <strong>Cost</strong> <span>{gift.cost}</span>
                </div>
                <div>
                  <strong>Category</strong> <span>{gift.category}</span>
                </div>
              </div>
              <div className="card-actions">
                <button
                  className="btn-delete"
                  onClick={() => {
                    if (hasDeleteGift) {
                      handleDeleteGift(gift.id)
                    } else {
                      handleNoAccess()
                    }
                  }}
                  disabled={!hasDeleteGift}
                  title={!hasDeleteGift ? "No access to delete" : ""}
                >
                  Delete
                </button>
                <button
                  className="btn-edit"
                  onClick={() => {
                    if (hasAddGift) {
                      handleEditClick(gift)
                    } else {
                      handleNoAccess()
                    }
                  }}
                  disabled={!hasAddGift}
                  title={!hasAddGift ? "No access to edit" : ""}
                >
                  Edit
                </button>
              </div>
            </div>
          ))}

        </div>

        {showFullImage && (
          <div className="full-image-overlay" onClick={closeFullImage}>
            <div className="full-image-container" onClick={(e) => e.stopPropagation()}>
              <button className="close-modal" onClick={closeFullImage}>&times;</button>
              <img src={currentFullImage} alt="Full Size" />
            </div>
          </div>
        )}
      </div>
    </IncludeSideBar>
  );
}

export default GiftsScreen;
